import { useEffect, useState } from "react";
import { getCategoryData } from "@/services/home-service";
import { GlobalSettings } from "@/configuration/global-settings";
import { AiOutlineClockCircle, AiOutlineEye } from "react-icons/ai";
import { HOMEPAGE_DATA_TYPE, NEWS_TYPE } from "@/components/helpers/constant";
import { Image, ScrollShadow, Link, Input } from "@nextui-org/react";
import CommonNews from "@/components/shared/common-news";
import Audios from "@/components/posts/audio-in-post";
import Categories from "@/components/posts/categories";
import LoadingCommon from "@/components/shared/loadingCommon";
import SharedServiceInstance from "@/services/shared-service";
import TitleTemplate from "@/components/shared/title-template";

import moment from 'moment';
import SharedService from "@/services/shared-service";
var _ = require('lodash');

export default function PostMoreBlock({ categoryID }) {
    const sharedService = SharedServiceInstance;
    const [audiosData, setAudiosData] = useState({});
    const [categoriesRelate, setCategoriesRelate] = useState([]);
    const [notifications, setNotifications] = useState(null);

    function getParables() {
        return getCategoryData(HOMEPAGE_DATA_TYPE.NOTIFICATIONS.link);
    }
    const fetchAudiosData = async () => {
        let url = '/api/audios?cid=' + categoryID;
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            setAudiosData(data)

            const currentCategory = _.find(sharedService.categories, item => item.code === categoryID);
            if (currentCategory) {
                const categorySubsData = _.filter(sharedService.categories, item =>
                    (item.parentId === currentCategory.parentId && item.level !== 0 && item.menu)
                    || item.id === currentCategory.parentId);
                setCategoriesRelate(categorySubsData);
            }
        })
    };
    useEffect( () => {
        getParables().then(resp => {
            setNotifications(resp);
        });
        if (categoryID) {
            fetchAudiosData();
        }
    }, [categoryID]);

    return <>
        {/* Categories Relate */}
        {categoriesRelate.length > 0 && <>
            <div className="mb-3">
                <Categories categories={categoriesRelate} categoryCode={categoryID} />
            </div>
        </>}

        {/* Email Signup - Action feature */}
        <div className="bg-white mb-3">
            <TitleTemplate titleName="Đăng ký nhận tin" />
            <div>
                <Input
                    size="lg"
                    key="none"
                    isDisabled // TODO:
                    radius="none"
                    type="text"
                    placeholder="Email của bạn"
                    className="font-semibold text-gray-500 p-2"
                    onChange={(e) => setChurchName(e.target.value)}
                />
            </div>
        </div>

        {/* Notifications Block */}
        <div className="bg-white mb-3">
            <TitleTemplate titleName={NEWS_TYPE.NOTIFICATIONS.name} />

            {(!notifications || notifications.total == 0) && <>
                <LoadingCommon />
            </>}

            <ScrollShadow hideScrollBar className="h-[250px] bg-white pt-2">
                {(notifications && notifications.total > 0) && notifications.value.map((notification, index) => {
                    return <>
                        <div key={index} className="grid grid-cols-3 pb-2 ml-2">
                            <div className="min-x-[103px]">
                                <Image
                                    alt={notification?.title} className="rounded-none h-[58px] sm:w-[103px]"
                                    src={sharedService.isValidUrl(notification.photo) ? `${sharedService.getOptimizeImage(notification.photo, 'main-post-view')}` : notification.photo? `${GlobalSettings.Settings.Server_New}/${notification.photo}` : "/assets/images/logo-for-web.png"}
                                />
                            </div>

                            <div className="col-span-2 px-3 my-auto">
                                <Link href={SharedService.getPostPath(notification)}>
                                    <h6 className="text-sm font-bold text-black md:line-clamp-2">{notification?.title}</h6>
                                </Link>

                                <div className="flex xl:pt-1 py-auto text-xs">
                                    <p className="inline-block my-auto">
                                        <AiOutlineClockCircle className="mr-2"/>
                                    </p> {moment(notification.publishDate).format('DD/MM/YYYY') || ''}
                                    <p className="inline-block my-auto pl-5">
                                        <AiOutlineEye className="mr-2"/>
                                    </p> {notification?.visit || 0}
                                </div>
                            </div>
                        </div>
                    </>
                })}
            </ScrollShadow>
        </div>

        {/* MostView Block */}
        <div className="bg-white mb-3">
            <TitleTemplate titleName={NEWS_TYPE.MOST_VIEW.name} />

            <CommonNews isMoreBlock={true} detailCode={NEWS_TYPE.MOST_VIEW.code} />
        </div>

        {/* Audios Block */}
        <div>
            {audiosData.total === 0
                && <>
                    <LoadingCommon itemName={'Audio'} />
                </>
            }

            {audiosData.total > 0
                && <>
                    <TitleTemplate titleName="Audio" link={"/audio"} />

                    <Audios audiosData={audiosData.value} isHasHeader/>
                </>
            }
        </div>
    </>
}
